import {isEqual} from 'lodash'
import {useNuxtApp} from 'nuxt/app'
import {defineStore} from 'pinia'
import {computed, ref} from 'vue'
import {useNotification} from '@/composables/useNotification'
import {tableStores} from "@/store/tableModules"
import {$larafetch} from '@/utils/$larafetch'

export const useMailStore = defineStore('mail', () => {
    const mailData = ref(null)
    const initialMailData = ref(null)
    const mailLoaded = ref(false)
    const mailDoesNotExist = ref(false)

    const mailDirty = computed(
        () => mailData.value && initialMailData.value && !isEqual(mailData.value, initialMailData.value)
    )

    function storeMailData(response) {
        mailData.value = {...response.data}
        initialMailData.value = {...response.data}
        mailLoaded.value = true
        mailDoesNotExist.value = false

        tableStores.mails().fetchData()
    }

    function handleRequestError(error) {
        const notification = useNotification()
        const app = useNuxtApp()
        mailLoaded.value = true
        if (error && error.response && error.response.mail === 422) {
            notification.error(app.$i18n.t('invalidRequestData') + '\n' + error.response._data.message)
        } else if (error && error.response && error.response.mail === 404) {
            mailDoesNotExist.value = true
            notification.error(app.$i18n.t('modelDoesNotExist'))
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if ( error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }

    function fetchMailData(id) {
        mailLoaded.value = false
        $larafetch(useNuxtApp().$apiRoute('spa.basedata.mails.show', {id}))
            .then(storeMailData)
            .catch(handleRequestError)
    }

    function resetData() {
        mailData.value = null
        initialMailData.value = null
        mailLoaded.value = false
        mailDoesNotExist.value = false
    }

    return {
        mailData,
        mailLoaded,
        mailDirty,
        mailDoesNotExist,
        fetchMailData,
        resetData,
    }
})
